<template>
    <div class="chart-container">
        <div class="button-group">
            <button @click="setTimeRange('week')">一周内数据</button>
            <button @click="setTimeRange('month')">30天内数据</button>
        </div>
        <div ref="lineChart" style="width: 100%; height: 300px;color:#5C16F2;margin-top: 10px"></div>
    </div>
</template>

<script>
    import * as echarts from 'echarts'; // 引入 ECharts

    export default {
        name: 'LineChart',
        data() {
            return {
                timeRange: 'week', // 默认展示一周内数据，记录当前选择的数据范围
                dates: [], // 存储用于图表x轴显示的日期数据
                salesData: [] // 存储对应的销量数据
            };
        },
        mounted() {
            this.initChart();
        },
        methods: {
            setTimeRange(range) {
                this.timeRange = range;
                this.initChart(); // 根据新选择的数据范围重新初始化图表
            },
            initChart() {
                const currentDate = new Date();
                this.dates = [];
                this.salesData = [];

                if (this.timeRange === 'week') {
                    // 获取当前日期前一周的数据
                    for (let i = 6; i >= 0; i--) {
                        const prevDate = new Date(currentDate);
                        prevDate.setDate(currentDate.getDate() - i);
                        this.dates.push(this.formatDate(prevDate));
                        // 这里可以根据实际情况获取对应日期的真实销量数据，目前先使用示例数据占位
                        this.salesData.push(this.getSalesData(prevDate));
                    }
                } else if (this.timeRange === 'month') {
                    // 获取当前日期前30天的数据
                    for (let i = 29; i >= 0; i--) {
                        const prevDate = new Date(currentDate);
                        prevDate.setDate(currentDate.getDate() - i);
                        this.dates.push(this.formatDate(prevDate));
                        // 这里可以根据实际情况获取对应日期的真实销量数据，目前先使用示例数据占位
                        this.salesData.push(this.getSalesData(prevDate));
                    }
                }

                const chartDom = this.$refs.lineChart;
                const myChart = echarts.init(chartDom);

                const option = {
                    title: {
                        text: '小程序票务销售额'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['销量']
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.dates
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '销量',
                            type: 'line',
                            stack: '总量',
                            data: this.salesData
                        }
                    ]
                };

                myChart.setOption(option);
            },
            // 格式化日期为 'YYYY-MM-DD' 格式
            formatDate(date) {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            // 根据日期获取销量数据的方法，目前返回示例数据，实际需替换为真实获取数据逻辑
            getSalesData(date) {
                // 这里可以根据日期去请求后端接口或者从本地存储等获取真实销量数据
                // 目前简单返回示例数据
                return Math.floor(Math.random() * 200); // 生成0-200之间的随机数作为示例销量数据
            }
        }
    }
</script>

<style lang="less">
    @import '../style/mixin';
   .line1 {
        display: flex;
        justify-content: center;
    }
   .button-group {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
    }
    button {
        margin: 0 5px;
    }
</style>